import { Page, View, Text, Image } from '@react-pdf/renderer';
import { styles } from './styles';
import {
  AgendaSpeaker,
  PublicEventDetailsResponse,
} from '@hubs101/booking-api-skd-client/lib/types';
import { globalStyles } from '../../styles';
import { useTranslation } from 'react-i18next';
import { getImageSrc } from '@utils/fn';

export interface AllSpeakerPageProps {
  event: PublicEventDetailsResponse;
  footer: JSX.Element;
  agendaSpeakers: AgendaSpeaker[];
}

const AllSpeakerPage = ({
  event,
  footer,
  agendaSpeakers,
}: AllSpeakerPageProps) => {
  const { t } = useTranslation();

  return (
    <Page size={{ width: 1440, height: 800 }} style={styles.page}>
      <View style={styles.fullWidthContainer}>
        <View style={styles.galleryContainer}>
          <View style={{ width: 220, height: 140 }}>
            <Text style={styles.pageTitle}>{t('speaker')}</Text>
            <View
              style={{
                ...globalStyles.lineBar,
                alignSelf: 'flex-start',
                borderColor: event?.design?.themeColor ?? 'black',
                marginTop: 20,
                marginLeft: 0,
                marginBottom: 5,
                width: 140,
              }}
            />
          </View>

          {(agendaSpeakers || []).map((speaker, index) => {
            const companyLogoSrc = getImageSrc(speaker?.company?.logo);
            const speakerImageSrc = getImageSrc(speaker?.images?.picture);

            return (
              companyLogoSrc &&
              speakerImageSrc && (
                // Add wrap false so speaker don't get cut
                <View style={styles.speakerItemWrapper} wrap={false}>
                  <View style={styles.leftColumn}>
                    <Image
                      key={index}
                      style={styles.speakerImage}
                      src={speakerImageSrc}
                    />
                    <Image
                      key={index}
                      style={styles.companyLogoImage}
                      src={companyLogoSrc}
                    />
                  </View>
                  <View style={styles.rightColumn}>
                    <Text style={styles.speakerNameText}>
                      {speaker?.first_name} {speaker?.last_name}
                    </Text>
                    <Text style={styles.speakerCompanyText}>
                      {speaker?.company?.name}
                    </Text>
                    <Text style={styles.speakerJobTitleText}>
                      {speaker?.job?.title}
                    </Text>
                  </View>
                </View>
              )
            );
          })}
        </View>
      </View>

      {footer}
    </Page>
  );
};

export default AllSpeakerPage;
